"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = require("../../command-expander");
exports.acuteAccent = command_expander_1.lookupOrAppend({
    e: "é",
    y: "ý",
    u: "ú",
    i: "í",
    o: "ó",
    a: "á",
    E: "É",
    Y: "Ý",
    U: "Ú",
    I: "Í",
    O: "Ó",
    A: "Á",
    cyrk: "ќ",
    cyrg: "ѓ",
    CYRK: "Ќ",
    CYRG: "Ѓ",
}, "\u0301");
//# sourceMappingURL=acute.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/unicode/commands/1args/diacritics/acute.js
// module id = 109
// module chunks = 0 1 2 3